import React from 'react'
import classnames from 'classnames'
import { errorBudge, textareaErrorBudge } from './Contact.module.scss'
import { InputWithLabel } from '../../ui/Input'
import { TextareaWithLabel } from '../../ui/Textarea'

type Props = {
	name: string
	nameFurigana: string
	company: string
	email: string
	phoneNumber: string
	content: string
	readOnly: boolean
	isSubmit?: boolean
	handleInputChange?: (e: React.FormEvent<HTMLInputElement>) => void
	handleTextareaChange?: (e: React.FormEvent<HTMLTextAreaElement>) => void
}

const ErrorBadge = () => {
	return (
		<div className={classnames(errorBudge, 'absolute top-3/4 left-1/3 p-2 w-44 bg-red')}>
			<p className="text-xs text-center text-secondary">このフィールドは必須です</p>
		</div>
	)
}

export const Form = ({
	name,
	nameFurigana,
	company,
	email,
	phoneNumber,
	content,
	readOnly,
	isSubmit,
	handleInputChange,
	handleTextareaChange,
}: Props) => {
	return (
		<>
			<div className="relative">
				<InputWithLabel
					className="flex flex-col mt-8 w-full"
					inputProps={{
						name: 'name',
						value: name,
						placeholder: '例）山田 太郎',
						readOnly: readOnly,
						className: `mt-2 ${isSubmit && !name ? 'border-red' : ''}`,
						onChange: handleInputChange,
					}}
					labelProps={{ label: 'お名前', required: true }}
				/>
				{isSubmit && !name ? <ErrorBadge /> : null}
			</div>
			<div className="relative">
				<InputWithLabel
					className="flex flex-col mt-8 w-full"
					inputProps={{
						name: 'nameFurigana',
						value: nameFurigana,
						placeholder: '例）ヤマダ タロウ',
						readOnly: readOnly,
						className: `mt-2 ${isSubmit && !nameFurigana ? 'border-red' : ''}`,
						onChange: handleInputChange,
					}}
					labelProps={{ label: 'お名前（フリガナ）', required: true }}
				/>
				{isSubmit && !nameFurigana ? <ErrorBadge /> : null}
			</div>
			<InputWithLabel
				className="flex flex-col mt-8 w-full"
				inputProps={{
					name: 'company',
					value: company,
					placeholder: '例）株式会社フードデリバリー',
					readOnly: readOnly,
					className: 'mt-2',
					onChange: handleInputChange,
				}}
				labelProps={{ label: '会社名', required: false }}
			/>
			<div className="relative">
				<InputWithLabel
					className="flex flex-col mt-8 w-full"
					inputProps={{
						type: 'email',
						name: 'email',
						value: email,
						placeholder: '例）example@lisatech.co.jp',
						readOnly: readOnly,
						className: `mt-2 ${isSubmit && !email ? 'border-red' : ''}`,
						onChange: handleInputChange,
					}}
					labelProps={{ label: 'メールアドレス', required: true }}
				/>
				{isSubmit && !email ? <ErrorBadge /> : null}
			</div>
			<InputWithLabel
				className="flex flex-col mt-8 w-full"
				inputProps={{
					name: 'phoneNumber',
					value: phoneNumber,
					placeholder: '例）01-234-5678',
					readOnly: readOnly,
					className: 'mt-2',
					onChange: handleInputChange,
				}}
				labelProps={{ label: '電話番号', required: false }}
			/>
			<div className={classnames('relative', textareaErrorBudge)}>
				<TextareaWithLabel
					className="flex flex-col mt-8 w-full"
					textareaProps={{
						name: 'content',
						value: content,
						placeholder: 'お問い合わせ内容をご記入ください',
						readOnly: readOnly,
						className: `mt-2 h-52 ${isSubmit && !content ? 'border-red' : ''}`,
						onChange: handleTextareaChange,
					}}
					labelProps={{ label: 'お問い合わせ内容', required: true }}
				/>
				{isSubmit && !content ? <ErrorBadge /> : null}
			</div>
		</>
	)
}
